import React from 'react';

const Header: React.FC = () => {
  return (
    <header>
      <img src="/images/logo-no-background.png" alt="Ainaeco Logo" className="logo" />
      <div className="header-right">
        <div className="status-indicator">
          <span className="status-dot"></span>
          <span>Coming Soon</span>
        </div>
        <a href="mailto:hello@ainaeco.uk" className="contact-btn">
          Contact Us
        </a>
      </div>
    </header>
  );
};

export default Header;
